import * as TracksActions from '../actions/tracks.actions';
import * as TracksApiActions from '../actions/tracks-api.actions';
import * as moment from 'moment-timezone';
import { RouteDetails } from '../../../shared/models/route-details';
import { chooseRoute } from '../actions/tracks.actions';

export interface State {
  routesMap: Map<number, Map<string, RouteDetails[]>>;
  routes: RouteDetails[];
  error: any;
  selectedRoutes: RouteDetails[];
  chosenRoutes: RouteDetails[];
  hoveredRouteIds: string[];
  clickedRouteIds: string[];
  hoveredStopRouteIds: string[];
  clickedStopRouteIds: string[];
  date: {
    dateFrom: string;
    dateTo: string;
  };
  routesLoading: boolean;
  activePlayer: string;
  selectedVehicles: Set<number>;
  vehiclesDetailsVisibility: boolean;
}


export const initialState: State = {
  routesMap: new Map<number, Map<string, RouteDetails[]>>(),
  routes: null,
  error: null,
  selectedRoutes: null,
  chosenRoutes: [],
  hoveredRouteIds: [],
  clickedRouteIds: [],
  hoveredStopRouteIds: [],
  clickedStopRouteIds: [],
  date: {
    dateFrom: moment().startOf('day').format(),
    dateTo:  moment().subtract(1, 'm').format()
  },
  routesLoading: false,
  activePlayer: null,
  selectedVehicles: new Set<number>(),
  vehiclesDetailsVisibility: false
};
export function reducer(
  state = initialState,
  action: TracksActions.TracksActionsUnion | TracksApiActions.TracksApiActionsUnion
): State {
  switch (action.type) {
    case TracksActions.getRoutes.type: {
      return {
        ...state,
        routesLoading: true,
      }
    }
    case TracksActions.getRoutesSummary.type: {
      return {
        ...state,
        routesLoading: true,
      }
    }
    case TracksApiActions.getRoutesSummarySuccess.type: {
      if (!action.unitIds) {
        return {
          ...state
        }
      }

      const newMap = new Map<number, Map<string, RouteDetails[]>>(state.routesMap);
      const params = JSON.stringify({dateFrom: action.params.dateFrom, dateTo: action.params.dateTo });
      // console.log('Reducer::getRoutesSummarySuccess', params); //.format('YYYY-MM-DD HH:mm:ssZ')
      if (action.unitIds) {
        action.unitIds?.forEach(unitId => {
          const data = action.data?.filter(r => r.unitId === unitId) || [];
          if (!newMap.has(unitId)) {
            newMap.set(unitId, new Map<string, RouteDetails[]>())
          }
          newMap.get(unitId).set(params, data);
        });
      }
      return {
        ...state,
        routesMap: newMap,
        routesLoading: false,
      };
    }
    case TracksApiActions.getRoutesSummaryFailure.type: {
      return {
        ...state,
        error: action.error,
        routesLoading: false,
      };
    }
    case TracksApiActions.getRoutesFailure.type: {
      return {
        ...state,
        routes: null,
        error: action.error,
        routesLoading: false,
      };
    }
    case TracksActions.selectRoutes.type: {
      return {
        ...state,
        selectedRoutes: action.routes,
      };
    }
    case TracksActions.clearRoutes.type: {
      return {
        ...state,
        selectedRoutes: [],
        routes: null,
        hoveredRouteIds: [],
        clickedRouteIds: [],
        activePlayer: null,
        chosenRoutes: [],
      };
    }
    case TracksActions.clearSelectedVehicles.type: {
      return {
        ...state,
        selectedVehicles: new Set<number>(),
      }
    }
    case TracksActions.clickedRoutes.type: {
      return {
        ...state,
        clickedRouteIds: [...action.routesIds],
      };
    }
    case TracksActions.hoveredRoutes.type: {
      return {
        ...state,
        hoveredRouteIds: [...action.routesIds],
      };
    }
    case TracksActions.clickedStopRoutes.type: {
      return {
        ...state,
        clickedStopRouteIds: [...action.routesIds],
      };
    }
    case TracksActions.hoveredStopRoutes.type: {
      return {
        ...state,
        hoveredStopRouteIds: [...action.routesIds],
      };
    }
    case TracksActions.clearRoutesCache.type: {
      state.routesMap.clear();
      return {
        ...state
      };
    }
    case TracksActions.setDate.type: {
      return {
        ...state,
        date: {dateFrom: action.date.dateFrom , dateTo: action.date.dateTo}
      };
    }
    case TracksActions.clearStopRoutes.type: {
      return {
        ...state,
        hoveredStopRouteIds: [],
        clickedStopRouteIds: []
      };
    }
    case TracksActions.addClickedRoute.type: {
      return {
        ...state,
        clickedRouteIds: [...state.clickedRouteIds, action.routeId],
      };
    }
    case TracksActions.removeClickedRoute.type: {
      return {
        ...state,
        clickedRouteIds: [...state.clickedRouteIds?.filter(x => x !== action.routeId)],
      };
    }
    case TracksActions.addHoveredRoute.type: {
      return {
        ...state,
        hoveredRouteIds: [...state.hoveredRouteIds, action.routeId],
      };
    }
    case TracksActions.removeHoveredRoute.type: {
      return {
        ...state,
        hoveredRouteIds: [...state.hoveredRouteIds?.filter(x => x !== action.routeId)],
      };
    }
    case TracksActions.addClickedStopRoute.type: {
      return {
        ...state,
        clickedStopRouteIds: [...state.clickedStopRouteIds, action.routeId],
      };
    }
    case TracksActions.removeClickedStopRoute.type: {
      return {
        ...state,
        clickedStopRouteIds: [...state.clickedStopRouteIds?.filter(x => x !== action.routeId)],
      };
    }
    case TracksActions.addHoveredStopRoute.type: {
      return {
        ...state,
        hoveredStopRouteIds: [...state.hoveredStopRouteIds, action.routeId],
      };
    }
    case TracksActions.removeHoveredStopRoute.type: {
      return {
        ...state,
        hoveredStopRouteIds: [...state.hoveredStopRouteIds?.filter(x => x !== action.routeId)],
      };
    }
    case TracksActions.selectActivePlayer.type: {
      return {
        ...state,
        activePlayer: action.uuid,
      };
    }
    case TracksActions.vehiclesDetailsVisibility.type: {
      return {
        ...state,
        vehiclesDetailsVisibility: action.visible,
      };
    }
    case TracksActions.selectVehicles.type: {
      const unitIds = new Set<number>(state.selectedVehicles);
      if (action?.unitIds) {
        action?.unitIds?.forEach(id => unitIds.has(id) ? unitIds.delete(id) : unitIds.add(id));
      } else {
        unitIds.clear();
      }
      return {
        ...state,
        selectedVehicles: unitIds,
      };
    }
    case TracksActions.setRoutesByUnitIds.type: {
      const selectedRoutes: RouteDetails[] = [];
      const params = JSON.stringify({dateFrom: state.date.dateFrom, dateTo: state.date.dateTo });
      action.unitIds?.forEach(unitId => {
        const routes = state.routesMap.get(unitId)?.get(params);
        if (routes) {
          selectedRoutes.push(...routes);
        }
      })
      return {
        ...state,
        routes: selectedRoutes,
      };
    }
    case TracksActions.chooseRoute.type: {
      const chosenRoutes: RouteDetails[] = [...state.chosenRoutes];
      const route = action.route;
      const routeIndex = chosenRoutes.findIndex(r => r.routeId === route.routeId);
      if (routeIndex > -1) {
        chosenRoutes.splice(routeIndex, 1);
      } else {
        chosenRoutes.push(route);
      }
      return {
        ...state,
        chosenRoutes: chosenRoutes,
      };
    }
    case TracksActions.setRoutesLoading.type: {
      return {
        ...state,
        routesLoading: action.isLoading,
      };
    }
    default: {
      return state;
    }
  }
}

export const getRoutes = (state: State) => state.routes;
export const getRoutesMap = (state: State) => state.routesMap;
export const getSelectedRoutes = (state: State) => state.selectedRoutes;
export const getChosenRoutes = (state: State) => state.chosenRoutes;
export const getHoveredRouteIds = (state: State) => state.hoveredRouteIds;
export const getClickedRouteIds = (state: State) => state.clickedRouteIds;
export const getClickedStopRouteIds = (state: State) => state.clickedStopRouteIds;
export const getHoveredStopRouteIds = (state: State) => state.hoveredStopRouteIds;
export const getDate = (state: State) => state.date;
export const areRoutesLoading = (state: State) => state.routesLoading;
export const getActivePlayer = (state: State) => state.activePlayer;
export const getSelectedVehicles = (state: State) => state.selectedVehicles;
export const getVehiclesDetailsVisibility = (state: State) => state.vehiclesDetailsVisibility;
export const getRoutesByParams = (state: State, params: any) => state.routesMap?.has(params?.unitId) ? state.routesMap?.get(params?.unitId).get(JSON.stringify({dateFrom: params?.dateFrom, dateTo: params?.dateTo})): null;
